import { KbCardPage } from "@/components/kb/KbCardPage";

export function Card005RoyVaniKindergartenAdaptation() {
  return <KbCardPage slug="card-005-roy-vani-kindergarten-adaptation" />;
}

(Card005RoyVaniKindergartenAdaptation as unknown as { path: string }).path = "/methodology/005";
